import React from 'react';
import { CardActions, useTheme } from '@mui/material';

/**
 * Sticky Save/Submit bar for drawer forms. Place it inside the Formik `<Form>` so its
 * buttons can submit; it stays at the bottom of the drawer while the content scrolls.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children The footer buttons.
 */
export const FolioDrawerFooter = ({ children }) => {
	const theme = useTheme();

	return (
		<CardActions
			sx={{
				position: 'sticky',
				bottom: 0,
				zIndex: 1,
				mt: 'auto',
				backgroundColor: theme.palette.background.paper,
				borderTop: `1px solid ${theme.palette.divider}`,
				justifyContent: 'center',
			}}
		>
			{children}
		</CardActions>
	);
};
